import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { WarnNotification } from 'app/models/warn-notification.model';
import { GenericMapComponent } from '../../generic-map/generic-map.component';
@Component({
    selector: 'app-last-status',
    templateUrl: './last-status.component.html',
    styleUrls: ['./last-status.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class LastStatusComponent  implements OnInit {
    @Output() public done = new EventEmitter();
    private _warnNotification:WarnNotification

    public get model() {
        return this._warnNotification
    }

    public set model(v: WarnNotification) {
        this._warnNotification = v;
    }

    constructor(private _dialog:MatDialog) {}

    public async ngOnInit() {

    }
    public async onMapClick(){
        const dialog = this._dialog.open(GenericMapComponent,{
        })
        dialog.componentInstance.latitude=parseFloat(this.model.device.deviceLatestStatus.gpS_Enlem)
        dialog.componentInstance.longitude=parseFloat(this.model.device.deviceLatestStatus.gpS_Boylam)
    }
}



